export const staticText = {
  noDataAvailable: '---'
};
